export const staticText = {
  noDataAvailable: '---'
};
